// material-ui
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useSelector } from 'react-redux';

function HTTPLoader  ()  {
    const isLoad = useSelector((state) => state.common.isLoad);
    return (
    <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={isLoad}
    >
        <CircularProgress color="inherit" />
    </Backdrop>);
};

export default HTTPLoader;
